/*global window, document, location, navigator, screen, app, webkit, localStorage */

// 1. Debug or minified
const search = location.search;
const isDebug = search.indexOf('debug') !== -1;

// 2. Desktop or mobile
const ua = navigator.userAgent;
const isMobile = /[?&](?:force_screenSize|ui)=desktop/.test(search)
    ? false
    : /[?&](?:force_screenSize|ui)=mobile/.test(search)
      ? true
      : // Always mobile for Android, iOS, Windows Mobile
        /Android|iP(?:ad|hone|od)|IEMobile/.test(ua)
        ? true
        : // Never mobile for desktop windows/mac/linux
          /Windows NT|OS X \d|\bX11\b/.test(ua)
          ? false
          : screen.width < 1024 &&
            (window.innerWidth < 600 || window.innerHeight < 600);

// 3. Are we in the app?
const isApp =
    typeof app === 'object' ||
    ua.indexOf(' FastMail/') > -1 ||
    /[?&]isApp=1/.test(search);

// 4. Do we have any info on sessions and which user to load?
let sessions = null;
const isOverride = /[?&]a=/.test(location.search);
if (!isOverride) {
    try {
        sessions = JSON.parse(localStorage.getItem('sessions'));
    } catch (error) {}
}

const user = /[?&]u=(\w+)/.exec(location.search);

// 5. Build our config file
const version = document.documentElement.getAttribute('data-version');
const FM = {
    isApp,
    isMobile,
    isDebug,

    version,
    pathToDist: '/static/jmapui' + (version ? '/' + version : ''),

    sessions,
    userId: user ? user[1] : '',

    doAction(type, args) {
        (FM._initActions || (FM._initActions = [])).push([type, args]);
    },
};

if (window.webkit?.messageHandlers?.didBootstrap) {
    webkit.messageHandlers.didBootstrap.postMessage({});
} else if (window.app?.didBootstrap) {
    try {
        app.didBootstrap(JSON.stringify({}));
    } catch {}
}

// --- helper object for DOM-interactive tests

if (!PRODUCTION) {
    FM.test = {};
}

// ---

export { FM };
